import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import axiosInstance from '../../utils/axiosSetup.js';
import Pagination from '../layouts/pagination.jsx';


const AllAnnouncements = () => {
    const user = JSON.parse(localStorage.getItem('userInfo'));
    const [announcements, setAnnouncements] = useState([]);
    const [currentPage, setCurrentPage] = useState(0);
    const [pageCount, setPageCount] = useState(0);
    
    const fetchAnnouncements = async (id, currentPage) => {
        try {
            const response = await axiosInstance.get(`${process.env.REACT_APP_API_URL}/getAnnouncementByUser/${id}?showAll=paginate&page=${currentPage + 1}`);
            const data = response.data.data;

            setAnnouncements(data.data);
            setPageCount(Math.ceil(data.total / data.per_page));
        } catch (error) {
            console.error("Error fetching announcements", error);
            setAnnouncements([]);
            setPageCount(0);
        }
    };

    
    useEffect(() => {
        fetchAnnouncements(user.id, currentPage);
    }, [currentPage]);
    
    const handlePageClick = (event) => {
        setCurrentPage(event.selected);
    };
    
    return(
        <>
            <div className="content container-fluid">
                <div className="page-header">
                    <div className="row align-items-center timeLog">
                        <div className="col">
                            <h3 className="page-title">All Announcements</h3>
                            <ul className="breadcrumb">
                                <li className="breadcrumb-item">
                                    <Link to="/dashboard">Dashboard</Link></li>
                                <li className="breadcrumb-item active">All Announcements</li>
                            </ul>
                        </div>
                    </div>
                </div>

                <div className="card">
                    <div className="card-body">
                        <div className="row">
                            <div className="col-md-12">
                                <div className="accordion accordions-items-seperate">
                                    {announcements.length > 0 ? (
                                        announcements.map((announcement, index) => (
                                            <div className="accordion-item mt-3 mb-3" key={index}>
                                                <h2 className="accordion-header" id={`panelsStayOpen-heading${index}`}>
                                                    <button className="accordion-button" type="button" data-bs-toggle="collapse"
                                                        data-bs-target={`#panelsStayOpen-collapse${index}`} aria-expanded="true"
                                                        aria-controls={`panelsStayOpen-collapse${index}`}>
                                                        {announcement.subject || ""}
                                                    </button>
                                                </h2>
                                                <div id={`panelsStayOpen-collapse${index}`} className="accordion-collapse collapse"
                                                    aria-labelledby={`panelsStayOpen-heading${index}`}>
                                                    <div className="accordion-body">
                                                        <i className="text-muted">{announcement.date}</i>
                                                        <div className="mt-2"
                                                            dangerouslySetInnerHTML={{ __html: announcement.message || "" }}></div>
                                                    </div>
                                                </div>
                                            </div>
                                        ))
                                    ) : (
                                        <div className="p-3 text-center">No announcement found.</div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <Pagination pageCount={pageCount} handlePageClick={handlePageClick}/>
            </div>

        </>
    );
}

export default AllAnnouncements